import styled from 'styled-components';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { OpenNewWindow16 } from 'ui/icons';
import { displayContent } from '../content';
import { useQueryParamContext } from '../../context/QueryParamContext';

const StyledLink = styled.a`
  &:hover {
    text-decoration: none;
  }
`;

type PreviewOnDevicesButtonProps = {
  size?: BUTTON_SIZES;
};

export const PreviewOnDevicesButton = ({
  size = BUTTON_SIZES.LARGE,
}: PreviewOnDevicesButtonProps) => {
  const { templateId } = useQueryParamContext();
  return (
    <StyledLink href={`/templates/devicePreview?templateId=${templateId}`} target="_blank">
      <Button
        data-test={'template-editor-preview-on-devices-button'}
        size={size}
        variant={BUTTON_VARIANTS.SECONDARY}
      >
        <span>{displayContent.btnPreviewOnDevices}</span>
        <OpenNewWindow16 isColorInherited={true} />
      </Button>
    </StyledLink>
  );
};

export default PreviewOnDevicesButton;
